import { TestimonialForm } from "./TestimonialForm";
import { SubBadge } from "@/components/admin/SectionShell";
import { TestimonialRow } from "./TestimonialRow";

export const TestimonialsManager = ({
  testimonials, setTestimonials, handleDrop, dragCtx,
  toggleFeatured, toggleTestimonialVisible, startEditT, deleteTestimonial,
  ...formProps
}) => (
  <div className="bg-white/80 border border-white/60 rounded-3xl p-6 mb-6" data-testid="testimonials-manager">
    <p className="font-serif text-2xl mb-4"><SubBadge /> Testimonials ({testimonials.length})</p>
    <TestimonialForm {...formProps} />
    {testimonials.length === 0 ? (
      <p className="text-muted-foreground text-sm">No testimonials yet.</p>
    ) : (
      <div className="space-y-3 max-h-[70vh] overflow-y-auto pr-1">
        <p className="text-xs text-muted-foreground">Drag the handle to reorder how they appear on the page.</p>
        {testimonials.map((t, i) => (
          <TestimonialRow
            key={t.id} t={t} index={i}
            onDragStart={(from) => { dragCtx.current = { type: "t", from }; }}
            onDrop={(to) => handleDrop("t", testimonials, setTestimonials, to, "/admin/testimonials/reorder")}
            toggleFeatured={toggleFeatured}
            toggleTestimonialVisible={toggleTestimonialVisible}
            startEditT={startEditT}
            deleteTestimonial={deleteTestimonial}
          />
        ))}
      </div>
    )}
  </div>
);
